import { ROLES } from './constants';

export const isExternalUser = (user) => {
    const EXTERNAL_ROLES = [ROLES.FACILITY_MANAGER, ROLES.ORGANIZATION_ADMIN, ROLES.EXTERNAL_USER];
    if (!user?.roles?.length) return false;

    return user.roles.every((role) => EXTERNAL_ROLES.includes(role));
};

export const isUserHasSomeRoles = (user, roles) => {
    if (!user?.roles?.length) return false;

    return user?.roles?.some((role) => roles.includes(role));
};

export const isUserHasAdminRoles = (user) => {
    const ADMIN_ROLES = [ROLES.ADMIN];
    return isUserHasSomeRoles(user, ADMIN_ROLES);
};
